import React from 'react';
import { Layout, Banner } from '@shopify/polaris';

// Shared full-page error banner - replaces the duplicated
// <Layout><Layout.Section><Banner tone="critical">...</Banner></Layout.Section></Layout> blocks.
const PageError = ({ children }) => (
  <Layout>
    <Layout.Section>
      <Banner tone="critical">{children}</Banner>
    </Layout.Section>
  </Layout>
);

export default PageError;
